if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    disconnectedCallback() {
      if (this.handleFacetFiltersUpdated) {
        document.removeEventListener(
          'on:facet-filters:updated',
          this.handleFacetFiltersUpdated
        );
      }
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector(
        '.main-products-grid__filters'
      );
      this.layoutSwitcher = this.querySelector(
        '.products-toolbar__layout'
      );
      this.compareToggle = document.getElementById('compare-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector(
        '.main-products-grid'
      );

      this.resultsCountNumber = this.querySelector(
        '.products-toolbar__count-number'
      );

      this.resultsCountLabel = this.querySelector(
        '.products-toolbar__count-label'
      );

      if (this.resultsCountLabel) {
        this.resultsCountType = this.resultsCountLabel.textContent
          .trim()
          .toLowerCase()
          .includes('result')
          ? 'result'
          : 'product';
      }

      if (this.filtersComponent && this.resultsCountNumber) {
        this.handleFacetFiltersUpdated =
          this.updateResultsCount.bind(this);

        document.addEventListener(
          'on:facet-filters:updated',
          this.handleFacetFiltersUpdated
        );
      }

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');

        this.filterToggle.addEventListener(
          'click',
          this.toggleFilters.bind(this)
        );
      }

      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener(
          'change',
          this.handleLayoutChange.bind(this)
        );

        const storedLayout = theme.storageUtil.get('products-layout');

        const isCollectionPage = Boolean(
          this.closest('.cc-collection-products')
        );

        const collectionDefault =
          isCollectionPage ? 'list' : 'grid';

        const layout =
          storedLayout === 'list' || storedLayout === 'grid'
            ? storedLayout
            : collectionDefault;

        const toggle = this.querySelector(
          `#${layout}-layout-opt`
        );

        if (toggle && this.productsGrid) {
          toggle.checked = true;
          this.productsGrid.dataset.layout = layout;
        }
      }

      if (this.compareToggle) {
        this.compareToggle.addEventListener(
          'change',
          this.toggleCompare.bind(this)
        );

        const isChecked = theme.storageUtil.get(
          'compare-toggle',
          true
        );

        if (isChecked !== null) {
          this.toggleCompare(null, isChecked, true);
        } else {
          this.toggleCompare(
            null,
            this.compareToggle.checked,
            false
          );
        }

        setTimeout(() => {
          this.classList.add('transition-ready');
          this.productsGrid.classList.add('transition-ready');
        }, 500);
      } else if (theme.settings.compareToggle === 'none') {
        this.toggleCompare(null, true, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener(
          'change',
          ProductsToolbar.handleSortByChange
        );
      }
    }

    updateResultsCount() {
      const resultsButton = document.querySelector(
        '.js-close-drawer-mob'
      );

      if (!resultsButton || !this.resultsCountNumber) {
        return;
      }

      const countMatch = resultsButton.textContent.match(/[\d,]+/);

      if (!countMatch) {
        return;
      }

      const formattedCount = countMatch[0];
      const numericCount = Number(
        formattedCount.replace(/,/g, '')
      );

      this.resultsCountNumber.textContent = formattedCount;

      if (
        this.resultsCountLabel &&
        Number.isFinite(numericCount)
      ) {
        this.resultsCountLabel.textContent =
          numericCount === 1
            ? this.resultsCountType
            : `${this.resultsCountType}s`;
      }
    }

    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;

      this.productsGrid.dataset.compare = isChecked;

      document
        .getElementById('compare-drawer-open')
        .classList.toggle('is-out', !isChecked);

      if (!evt && this.compareToggle) {
        this.compareToggle.checked = isChecked;
      }

      if (persist && !Shopify.designMode) {
        theme.storageUtil.set(
          'compare-toggle',
          isChecked
        );
      }

      if (isChecked) {
        const resourcesTag =
          document.getElementById('compare-resources');

        if (resourcesTag) {
          JSON.parse(resourcesTag.textContent).forEach(
            (resource) => {
              if (resource.type === 'js') {
                const script =
                  document.createElement('script');

                script.src = resource.path;
                document.head.appendChild(script);
              } else if (resource.type === 'css') {
                const link =
                  document.createElement('link');

                link.href = resource.path;
                link.type = 'text/css';
                link.rel = 'stylesheet';
                document.head.appendChild(link);
              }
            }
          );

          resourcesTag.remove();
        }
      }
    }

    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');

      this.filtersOpen =
        this.filterToggle.classList.contains('is-active');

      this.filterToggle.setAttribute(
        'aria-expanded',
        this.filtersOpen
      );

      if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle(
          'lg:js-hidden',
          !this.filtersOpen
        );

        const productsList = document.querySelector(
          '.main-products-grid__results > .grid'
        );

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
      } else {
        this.filtersComponent.open();
      }
    }

    handleLayoutChange(evt) {
      this.productsGrid.dataset.layout = evt.target.value;

      theme.storageUtil.set(
        'products-layout',
        evt.target.value
      );
    }

    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);

      urlObj.searchParams.set(
        'sort_by',
        evt.detail.selectedValue
      );

      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }
  }

  customElements.define(
    'products-toolbar',
    ProductsToolbar
  );
}
